'use client';

import Script from 'next/script';

import { useConsent } from '@/lib/useConsent';

const MEASUREMENT_ID = 'G-RSL97K5ZLM';
const IS_PRODUCTION = process.env.NODE_ENV === 'production';

export function GoogleAnalytics() {
	const consent = useConsent();
	if (!IS_PRODUCTION || consent !== 'accepted') return null;

	return (
		<>
			<Script
				src={`https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`}
				strategy="afterInteractive"
			/>
			<Script id="google-analytics" strategy="afterInteractive">
				{`
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${MEASUREMENT_ID}');
`}
			</Script>
		</>
	);
}
